import { map } from 'lodash';
import { createSlice } from '@reduxjs/toolkit';
import { filter } from 'lodash';
import axios from 'utils/axios';

const initialState = {
  isLoading: false,
  error: false,
  userList: [],
};

const slice = createSlice({
  name: 'user',
  initialState,
  reducers: {
    startLoading(state) {
      state.isLoading = true;
    },

    hasError(state, action) {
      state.isLoading = false;
      state.error = action.payload;
    },

    deleteUser(state, action) {
      const deleteUser = filter(state.userList, (user) => user.id !== action.payload);
      state.userList = deleteUser;
    },

    getUserListSuccess(state, action) {
      state.isLoading = false;
      state.userList = map(action.payload, (user) => ({
        ...user,
        name: `${user.firstName || ''} ${user.lastName || ''}`.trim() || user.email,
      }));
    },
  },
});

export default slice.reducer;
export const { onToggleFollow, deleteUser } = slice.actions;

export function createCustomerUser(customerId, payload) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.post(`/customers/${customerId}/users`, payload);
      dispatch(getUserList(customerId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function patchCustomerUser(customerId, userId, body) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      await axios.patch(`/customers/${customerId}/users/${userId}`, body);
      dispatch(getUserList(customerId));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
      throw error;
    }
  };
}

export function getUserList(customerId) {
  return async (dispatch) => {
    dispatch(slice.actions.startLoading());
    try {
      const response = await axios.get(`/customers/${customerId}/users`);
      dispatch(slice.actions.getUserListSuccess(response));
    } catch (error) {
      dispatch(slice.actions.hasError(error));
    }
  };
}

export function patchUserOrganizationRole(customerId, userId, organizationRole) {
  return patchCustomerUser(customerId, userId, { organizationRole });
}
